import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [{
    name: 'emails',
    url: '/emails',
    component: 'wtEmailsState',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve,
        roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer])
    },
    data: {
        sortingOrder: -1,
        visible: false,
        icon: '',
        displayName: 'E-mails',
        editRoles: [Roles.administrator, Roles.master, Roles.engineer],
        editButtonVisibility: () => true
    }
}];

export default states;